var red = {
  100: '#FFF5F1',
  200: '#FBD9CC',
  300: '#F8BCA8',
  400: '#EB8765',
  500: '#D65A34',
  600: '#B63813',
  700: '#8A2002',
  800: '#571200',
  900: '#260800'
};
export default red;